import { makeStyles } from '@mui/styles'

const styles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: 10,
    fontSize: 18,
    flexDirection: 'column',
    paddingBottom: 20,
  },

  topBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1.5rem',
    width: '95%',
    maxWidth: 'calc(95vw - 1rem)',
  },

  tableContainer:{
    width: '95%',
    overflowX: 'auto',
    boxShadow: '0px 0px 0px 0px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',

  },

  loading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '90vh',
    flexDirection: 'column',
  },

  loadingText: {
    marginTop: 20,
  },

  containers: {
    display: 'flex',
    flexDirection: 'row',
  },

  dataContainer: {
    margin: 20,
    padding: 15,
    backgroundColor: '#FFFFFF',
    width: 500,
    height: 300,
    boxShadow: '0px 0px 5px grey',
    borderRadius: 10,
  },

  modal: {
    display: 'flex',
    backgroundColor: '#FFFFFF',
    minHeight: 150,
    borderRadius: '10px',
    width: '80%',
    padding: '50px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
  },
}))

export default styles
